export interface ErrorEmailData {
    userEmail: string;
    errorMessage: string;
    errorDetails?: string;
    studyCondition?: string;
    timestamp: string;
    stackTrace?: string;
  }
  
  /**
   * Sends an error notification email when upload fails
   * @param emailData - Contains error details and user information
   * @param authToken - Authentication token for API call
   * @returns Promise<boolean> - Returns true if email sent successfully
   */
  export const sendErrorEmail = async (
    emailData: ErrorEmailData,
    authToken: string
  ): Promise<boolean> => {
    try {
      const config = (window as any).data;
      const emailServiceURL = config?.email?.emailServiceURL || 
                             'https://send-error-mail-56306138088.us-central1.run.app';
  
      const response = await fetch(emailServiceURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          to: emailData.userEmail,
          subject: 'Upload Error Notification - Stratagen Bio',
          errorMessage: emailData.errorMessage,
          errorDetails: emailData.errorDetails,
          studyCondition: emailData.studyCondition,
          timestamp: emailData.timestamp,
          stackTrace: emailData.stackTrace,
        }),
      });
  
      if (!response.ok) {
        return false;
      }

      return true;
    } catch (error) {
      return false;
    }
  };
